// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import React from 'react'
import { string } from 'prop-types'

const SimpleCell = ({ id, value }) => (
  <td
    id={id}
    title={value}>
    {value}
  </td>
)

SimpleCell.propTypes = {
  id: string.isRequired,
  value: string.isRequired,
}

export default SimpleCell
